export default __webpack_public_path__ + "static/walls-ytong-767086d7dff69925d69bae7550aa28b4.jpg";